import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { DependencyAllTables } from '../documentationContent';

const markdownComponents = {
    table: ({ children }) => (
        <div className="table-responsive">
            <table className="table table-sm table-striped table-bordered align-middle mb-4">
                {children}
            </table>
        </div>
    )
};

const DependencyDocumentation = () => {
    return (
        <div>
            <h1>Tool Dependency Summary</h1>
            <ReactMarkdown remarkPlugins={[remarkGfm]} components={markdownComponents}>
                {DependencyAllTables}
            </ReactMarkdown>
        </div>
    );
};

export default DependencyDocumentation;
